export default {
    APPS_LIST_ITEM: '@@AppsListItem',
    APP_DETAILS: '@@AppDetails',
};
